import { Link } from 'react-router-dom';
const PositionHelperLinks = () => {
	return (
		<>
			<strong>
				Click{' '}
				<Link
					to={{
						pathname:
							'/ViewDocument.aspx?doc=EPICCARE_ROLE_DESCRIPTIONS_II.pdf',
					}}
					label='here'
					target='_blank'
				>
					here
				</Link>{' '}
				to see position descriptions.
			</strong>
		</>
	);
};

export default PositionHelperLinks;
